<template>

    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-location-pin" /> Map View
      </div>
        <CRow>
            <CCol md="12" class="pad-r-0 pad-l-0">
                <CCard>
                    <CCardBody>
                        <CRow>
                            <CCol sm="12">
                                <h4 id="traffic" class="card-title mb-0">Data Filters</h4>
                                <small v-if="items.length > 0"><i>Showing {{items.length}} results</i></small>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="3">
                                <CCallout color="info">
                                <CForm>
                                    <CSelect
                                        label="Select a cirlce"
                                        :options="circle"
                                        :value.sync="selected.circle"
                                        @change="getArea('division', selected.circle, null, null, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="danger">
                                <CForm>
                                    <CSelect
                                        label="Select a division"
                                        :options="division"
                                        :value.sync="selected.division"
                                        @change="getArea('range', selected.circle, selected.division, null, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="warning">
                                <CForm>
                                    <CSelect
                                        label="Select a range"
                                        :options="range"
                                        :value.sync="selected.range"
                                        @change="getArea('block', selected.circle, selected.division, selected.range, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="primary">
                                <CForm>
                                    <CSelect
                                        label="Select a block"
                                        :options="block"
                                        :value.sync="selected.block"
                                        @change="getArea('beat', selected.circle, selected.division, selected.range, selected.block)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="3">
                                <CCallout color="danger">
                                <b>Select Time Interval</b>
                                <CInputRadioGroup
                                    name="sourceTypeRadio"
                                    checked="month"
                                    :options="timeTypeRadio"
                                    :value.sync="selected.sourceType"
                                    @update:checked="updateSourceType"
                                />
                                </CCallout>
                            </CCol>
                            <CCol sm="6" v-if="selected.sourceType == 'month'">
                                <CInput
                                    label="Select any date from desired month"
                                    type="date"
                                    v-model="selected.date"
                                />
                            </CCol>
                            <CCol sm="6" v-if="selected.sourceType == 'year'">
                                <CInput
                                    label="Select any date from desired year"
                                    type="date"
                                    v-model="selected.date"
                                />
                            </CCol>
                            <CCol sm="3" v-if="selected.sourceType == 'range'">
                                <CInput
                                    label="Select Start Date"
                                    type="date"
                                    v-model="selected.startDate"
                                />
                            </CCol>
                            <CCol sm="3" v-if="selected.sourceType == 'range'">
                                <CInput
                                    label="Select End Date"
                                    type="date"
                                    v-model="selected.endDate"
                                />
                            </CCol>
                            <CCol sm="3">
                                <CSelect
                                    label="Species Name"
                                    :options="animalOptions"
                                    placeholder="Select an animal"
                                    :value.sync="filter.animal"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="9" class="text-center">
                                <div style="min-height : 25px"><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                                <CInput 
                                    placeholder="Start typing phone number or name to search userwise.."
                                    v-model="searchText"
                                >
                                    <template #prepend>
                                        <CButton color="primary" @click="getData()">
                                        <CIcon name="cil-magnifying-glass"/> Search
                                        </CButton>
                                    </template>
                                </CInput>
                            </CCol>
                            <CCol sm="3">
                                <CSelect
                                    label="Sighting Type"
                                    :options="sightingTypeOptions"
                                    placeholder="Select a type"
                                    :value.sync="filter.sightingType"
                                />
                            </CCol>
                        </CRow>
                    </CCardBody>   
                    <CCardFooter class="text-center">
                        <CButton type="submit" size="sm" color="danger mr-4" @click="reset()"><CIcon name="cil-reload"/> Reset Filters</CButton>
                        
                        <CButton type="submit" size="sm" color="primary ml-4" @click="apply()"><CIcon name="cil-check-circle"/> Apply Filters</CButton>
                    </CCardFooter>   
                </CCard>
                <CCard>
                    <!-- <CCardHeader>
                        <CRow >
                            <CCol class="text-center">
                                <strong>Filters <small v-if="items.length > 0"><i>Showing {{items.length}} results</i></small></strong>
                            </CCol>                            
                        </CRow>
                        <CRow >
                            <CCol sm="3">
                                <CSelect
                                    label="Species Name"
                                    :options="animalOptions"
                                    placeholder="Select an animal"
                                    :value.sync="filter.animal"
                                />
                            </CCol>
                            <CCol sm="3">
                                <CSelect
                                    label="Sighting Type"
                                    :options="sightingTypeOptions"
                                    placeholder="Select a type"
                                    :value.sync="filter.sightingType"
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                    label="From"
                                    type="date"
                                    v-model="filter.fromDate"
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                    label="To"
                                    type="date"
                                    v-model="filter.toDate"
                                />
                            </CCol>                       
                        </CRow>
                        <CRow class="text-center">  
                            <CCol sm="12">
                                <CButton type="submit" size="sm" color="danger mr-4" @click="reset()"><CIcon name="cil-reload"/> Reset Filters</CButton>
                        
                                <CButton type="submit" size="sm" color="primary ml-4" @click="apply()"><CIcon name="cil-check-circle"/> Apply Filters</CButton>
                            </CCol>                      
                        </CRow>
                    </CCardHeader> -->
                    <CCardBody style="height: 65vh; width: 100%">
                        <l-map
                            v-if="!loading"
                            :zoom="zoom"
                            :center="center"
                            :options="mapOptions"
                            @update:center="centerUpdate"
                            @update:zoom="zoomUpdate"
                        >
                            <l-tile-layer
                                :url="url"
                                :attribution="attribution"
                            />

                            <l-geo-json
                                :geojson="stateBoundary"
                                :optionsStyle="stateStyle"
                            />


                            <l-marker v-for="record in items" v-bind:key="record._id" :lat-lng="getLatLng(record.location.coordinates[1],record.location.coordinates[0])" :icon="record.status !== 'Case Closed' ? redIcon : greenIcon">
                                <l-popup>
                                <div>
                                    <!-- <img :src="record.image === undefined ? '/img/noimage.png' : baseURL + record.image" style="max-height : 100px"><br> -->
                                    <b>{{record.sighting_type}}</b><br>
                                    Species : <b>{{record.animal_count}} {{record.species}}</b><br>
                                    Forest Type : <b>{{record.forest_type}}</b><br>
                                    Terrain Type : <b>{{record.terrain_type}}</b><br>                                    
                                    Date : <b>{{record.datetime.substring(0,10)}}</b><br>
                                    Reported By : 
                                        <ul>
                                            <li><b>{{record.userid.firstname}} {{record.userid.lastname}}</b></li>
                                            <li>{{record.userid.phone}}</li>
                                        </ul>
                                    <CButton size="sm" color="success"  @click="openReport(record.sightingid)"> Open </CButton>
                                </div>
                                </l-popup>
                            </l-marker>
                            <l-control
                                :position="'bottomleft'"
                                class="custom-control-watermark"
                            >
                                Map generated by Strofes Technologies
                            </l-control>
                        </l-map>

                        <grid-loader :loading="loading" color="#2E7D32" ></grid-loader>
                                         
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>        
    </div>
    <!-- <div style="height: 75vh; width: 100%" >
        <l-map
            v-if="!loading"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker v-for="record in items" v-bind:key="record._id" :lat-lng="getLatLng(record.location.coordinates[1],record.location.coordinates[0])" :icon="record.status !== 'Case Closed' ? redIcon : greenIcon">
                <l-popup>
                <div>
                    <img :src="record.image === undefined ? '/img/noimage.png' : baseURL + record.image" style="max-height : 100px"><br>
                    <b>{{record.sighting_type}}</b><br>
                    Species : <b>{{record.animal_count}} {{record.species}}</b><br>
                    Forest Type : <b>{{record.forest_type}}</b><br>
                    Terrain Type : <b>{{record.terrain_type}}</b><br>                                    
                    Date : <b>{{record.datetime.substring(0,10)}}</b><br>
                    Reported By : 
                        <ul>
                            <li><b>{{record.userid.name}}</b></li>
                            <li>{{record.userid.phone}}</li>
                        </ul>
                    <CButton size="sm" color="success"  @click="openReport(record.sightingid)"> Open </CButton>
                </div>
                </l-popup>
            </l-marker>
            <l-control
                :position="'bottomleft'"
                class="custom-control-watermark"
            >
                Map generated by Strofes Technologies
            </l-control>
        </l-map>

        <grid-loader :loading="loading" color="#2E7D32" ></grid-loader>
    </div> -->
</template>
<script>
import axios from 'axios';
import store from '../store';
import himachal from '../boundary';
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LGeoJson } from "vue2-leaflet";
import { Icon } from 'leaflet';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
    name : 'JW_Maps',
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
        LControl,
        Icon,
        GridLoader,
        PulseLoader,
        LGeoJson,
    },
    mounted(){
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.redIcon = L.icon({
            iconUrl: 'img/red_map_icon.png',
        });
        this.greenIcon = L.icon({
            iconUrl: 'img/green_map_icon.png',
        });
    },
    data() {
        return {
            baseURL : store.state.baseURL,

            items: [],
            tableLength : 0,

            zoom: 7.5,
            bounds: null,            
            center: latLng(31.8005297, 77.0516811),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            withPopup: latLng(47.41322, -1.219482),
            withTooltip: latLng(47.41422, -1.250482),
            currentZoom: 7,
            currentCenter: latLng(31.8005297, 75.0516811),
            showParagraph: true,
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            redIcon : null,
            greenIcon : null,
            loading : true,
            filter : {
                fromDate : '',
                toDate : '',
                surveyid : '',
                animal : '',
                sightingType : ''
            },
            searchText : '',
            sightingTypeOptions : [
                "Direct Sighting",
                "Indirect Sighting",
                "Animal Rescued",
                "Animal Mortality"
            ],
            animalOptions : [
                "Snow Leopard",
                "Leopard",
                "Himalayan Tahr",
                "Himalayan Ibex",
                "Musk Deer",
                "Barking Deer",
                "Himalayan Black Bear",
                "Brown Bear",
                "Spotted Deer",
                "Yellow Throated Martin",
                "Blue Bull",
                "Monal",
                "Red jungle Fowl",
                "Cheer Pheasant",
                "Kalij Pheasant",
                "Red Headed Vulture",
                "Himalayan Griffon Vulture",
                "Wild Boar",
                "Himalayan Yak",
                "Monkey",
                "Snake",
                "Vulture",
                "Musk Deer",
                "Other"
            ],

            stateBoundary : himachal,
            stateStyle : {
                "color": "#F44336",
                "weight": 1,
                "opacity": 0.5
            },
            selected : {
                circle : null,
                range : null,
                division : null,
                block : null,
                beat : null,
                areaType : null,
                sourceType : null,
                date : null,
                startDate : null,
                endDate : null
            },

            circle  : [],
            range   : [],
            block   : [],
            beat    : [],
            division: [],
            beatLength : 0,
            beatName : '',

            timeTypeRadio : [
                { value: 'month', label: 'Monthly Data' },
                { value: 'year',  label: 'Yearly Data' },
                { value: 'range', label: 'Date Range' },
            ]


        }
    },
    created() {
        this.loading = true;
        this.selected.areaType = 'circle';
        this.selected.sourceType = 'month';  
        this.getRecords();
        this.getArea('circle', null, null, null, null);
    },
    methods: {
        updateSourceType(value, event){
            this.selected.sourceType = value;
        },
        apply(){
            var errors = "";
            
            if(this.selected.sourceType == 'range' && (this.selected.startDate == null && this.selected.endDate == null)){
                errors += "Date range cannot be null\n";
            }

            if(errors != "")
            {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: errors
                });
            }
            else{
                this.getData();
            }

        },
        getData(){
            this.loading = true;
            axios({
                url : this.baseURL + "dashboard/search-sighting?p="+1,
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    date : this.selected.date == '' ? null : this.selected.date,
                    startDate : this.selected.startDate,
                    endDate : this.selected.endDate,
                    sourceType : this.selected.sourceType,
                    c : this.selected.circle,
                    d : this.selected.division,
                    r : this.selected.range,
                    b : this.selected.block,
                    userSearch : this.searchText,
                    animal      : this.filter.animal  == '' ? null : [this.filter.animal],
                    sightingType: this.filter.sightingType == '' ? null : [this.filter.sightingType]
                    
                }
            })
            .then(res => {
                if(res.data.status)
                {                
                    this.items = res.data.data
                    this.tableLength = this.items.length;            
                }
                else{
                    this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Something went wrong',
                    text: 'Error in loading data. Something went wrong!'
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Important message',
                    text: 'Error in loading data. Please check your internet connection!'
                });
                console.log(err);
                this.loading = false;
            });
        },
        getArea(type, circle, division, range, block){
            var url = this.baseURL + "area/get-distinct?t=" + type;

            if(circle != null)
                url += "&c=" + circle;

            if(division != null)
                url += "&d=" + division;
            
            if(range != null)
                url += "&r=" + range;

            if(block != null)
                url += "&b=" + block;
            

            axios({
                url : url,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {
                    if(type == 'circle'){
                        this.division = [];
                        this.range = [];
                        this.block = [];
                        this.selected.division = null;
                        this.selected.range = null;
                        this.selected.block = null;
                        this.circle = res.data.data; 
                    }   
                    else if(type == 'division'){
                        this.range = [];
                        this.block = [];
                        this.selected.division = null;
                        this.selected.range = null;
                        this.selected.block = null;
                        this.division = res.data.data;      
                                
                    }   
                    else if(type == 'range'){
                        this.block = [];
                        this.selected.range = null;
                        this.selected.block = null;
                        this.range = res.data.data;           
                    }    
                    else if(type == 'block'){
                        this.selected.block = null;
                        this.block = res.data.data;             
                    }   
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: 'Could not load ' + type + '.\n' + res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch ' + type
                });
                console.log(err);
            });
        },
        reset(){
            this.filter = {
                fromDate : '',
                toDate : '',
                surveyid : '',
                animal : '',
                sightingType : ''
            }
            this.selected.date = '';
            this.selected.startDate = '';
            this.selected.endDate = '';
            this.items = [];
            this.tableLength = 0;
            this.searchText = '',
            

            this.getRecords();
        },
        getLatLng(lat, lng){
            return latLng(lat, lng);
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        showLongText() {
            this.showParagraph = !this.showParagraph;
        },
        innerClick() {
            alert("Click!");
        },
        getRecords(){
            this.loading = true;
            axios({
                url : this.baseURL + "dashboard/all-sighting",
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                this.loading = false;
                if(res.status)
                {                    
                    this.items = res.data.data
                    this.tableLength = this.items.length;
                    return res.data.data;                    
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Something went wrong!\nCouldn\'t fetch data'
                    });
                    return [];
                }
            })
            .catch(err => {                
                this.loading = false;
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch data\n\n' + err
                });
                console.log(err);
                return [];
            });

        },
        getBadge (status) {
            return status === 'Pending' ? 'danger'
                : status === 'Received' ? 'warning'
                : status === 'Responded' ? 'focus'
                : status === 'Compensation Filed' ? 'info'
                : status === 'Compensation Pending' ? 'warning'
                : status === 'Compensation Sanctioned' ? 'success'             
                : status === 'Case Closed' ? 'primary' : 'primary'
        },
        openReport(caseid){
            this.$router.push({ path: `/sightings/${caseid}` });
        },
        // reset(){
        //     this.filter = {
        //         fromDate : '',
        //         toDate : '',
        //         surveyid : ''
        //     }
        //     this.searchText = '',

        //     this.getRecords();
        // },
        // apply(){
        //     if(
        //         this.filter.fromDate == '' &&
        //         this.filter.toDate  == '' &&
        //         this.filter.animal == '' &&
        //         this.filter.sightingType == ''
        //     ){
        //         this.$notify({
        //             group: 'notification',
        //             type : 'warn',
        //             title: 'Important message',
        //             text: 'Cannot apply empty filters'
        //         });
        //     }
        //     else{
        //         this.loading = true;
        //         axios({
        //             url : this.baseURL + "dashboard/search-sighting?p="+1,
        //             headers : {
        //                 authorization : store.state.token
        //             },
        //             method : "POST",
        //             data : {
        //                 startDate   : this.filter.fromDate == '' ? null : this.filter.fromDate,
        //                 endDate     : this.filter.toDate  == '' ? null : this.filter.toDate,
        //                 animal      : this.filter.animal  == '' ? null : [this.filter.animal],
        //                 sightingType: this.filter.sightingType == '' ? null : this.filter.sightingType
        //             }
        //         })
        //         .then(res => {
        //             this.loading = false;
        //             if(res.data.status)
        //             {                    
        //                 this.items = res.data.data
        //                 this.tableLength = this.items.length;
        //                 return res.data.data;                    
        //             }
        //             else
        //             {
        //                 this.$notify({
        //                     group: 'notification',
        //                     type : 'error',
        //                     title: 'Important message',
        //                     text: res.data.message
        //                 });
        //                 this.items = [];
        //                 return [];
        //             }
        //         })
        //         .catch(err => {                
        //             this.loading = false;
        //             this.$notify({
        //                 group: 'notification',
        //                 type : 'error',
        //                 title: 'Important message',
        //                 text: 'Something went wrong!\nCouldn\'t fetch data\n\n' + err
        //             });
        //             console.log(err);
        //             return [];
        //         });

        //     }            
        // },
    }
}
</script>